import React, {
  forwardRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import Button from '../../../components/Button';
import Loader from '../../../components/Loader';
import { AdminContext } from '../../../context/AdminContext';
import AppIcons from '../../../icons';
import FooterMoreBox from '../../../components/FooterMoreBox';
import styles from './styles.module.css';
import CenterModal from '../../../components/CenterModal';
import ShareUsersContent from '../../../components/ShareUsersContent';
import FindFileFormat from '../../../functions/FindFileFormat';
import SHARED from '../../../constants';
import ReplyBox from '../ReplyBox';
import FileButton from '../../../components/FileButton';
import ForwardMessages from '../../../components/ForwardMessages';
import Emoji from '../../../components/Emoji';
import attachIcon from '../../../../../assets/imgs/attachIcon.svg';
// import { AdminContext } from '../../../../context/AdminContext';
// import Button from '../../Button';
// import Loader from '../../Loader';

const ChatFooter = forwardRef((props, ref) => {
  const [type, setType] = useState([]);
  const {
    direction,
    openShare,
    setOpenShare,
    userChosenForShare,
    setUserChosenForShare,
    setShowSearch,
    setShowFirstMessage,
    themeColor,
    setNotificationText,
    // setopenNotificationModalError,
    login,
    setTrigger,
    videoChatSize,
    userChannelId,
    setShowAbsolute,
    activeUser,
    sharedUserClicked,
    setSharedUserClicked,
    setShowUsers,
    content,
    forwardMessages,
    setForwardMessages,
    themeMode,
    setSearchValue,
  } = useContext(AdminContext);
  const [showEmoji, setShowEmoji] = useState(false);
  // useEffect(() => {}, [fileSize]);
  const shareModalRef = useRef(null);
  const emojiRef = useRef(null);
  console.log('fileSize', videoChatSize, props, login);
  console.log('forwardmessage', forwardMessages);
  const checkIfClickedOut = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      shareModalRef &&
      shareModalRef.current &&
      !shareModalRef.current.contains(e.target)
    ) {
      setOpenShare(false);
      setUserChosenForShare({});
      console.log('firstdepen');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOut);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOut);
    };
  }, [openShare]);

  const checkIfClickedOutEmoji = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (emojiRef && emojiRef.current && !emojiRef.current.contains(e.target)) {
      setShowEmoji(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutEmoji);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutEmoji);
    };
  }, [showEmoji]);

  useEffect(() => {
    let allowed = [];
    props?.fileType?.map((x) => {
      allowed = allowed.concat(x.mimeType);
    });
    setType(allowed);
  }, []);
  const handleTyping = () => {
    props?.setServerError('');
    if (document.getElementById('fileUploadChat')) {
      document.getElementById('fileUploadChat').value = '';
    }
    // if (socket) {
    if (props?.message?.trim()?.length != 0) {
      if (props?.chatTypePrivate) {
        ref?.current?.emit(
          'private:typing',
          {
            type: `is typing`,
            uuid: userChannelId,
            typeId: activeUser?.typeId,
            roomId: activeUser?.id,
          },
          (response) => {
            if (response?.status == 'error') {
              props?.setServerError(response?.message);
            } else {
              props?.setServerError('');
            }
          }
        );
      } else {
        ref?.current?.emit(
          'multiple:typing',
          `${localStorage.getItem('userName')} is typing`,
          (response) => {
            if (response?.status == 'error') {
              props?.setServerError(response?.message);
            } else {
              props?.setServerError('');
            }
          }
        );
      }
    } else {
      props?.notTyping();
    }
    // }
  };
  const textareaKeydown = (e) => {
    //  ||  (e.keyCode === 10) ==> return keycode?
    if ((e.key === 'Enter' && (e.metaKey || e.ctrlKey)) || e.key === 'Return') {
      console.log('return');
      props?.setMessage(e?.target?.value + ' \n ');
    } else if (e.keyCode === 13 && e.shiftKey) {
      // props?.setMessage(e?.target?.value + ' \n ');
      return false;
    } else if (e.keyCode === 13) {
      login && !props?.loadingFileButton
        ? props?.loadingFile
          ? console.log('loading')
          : checkIfConnected('', e)
        : e.preventDefault();
      console.log('loading');
    } else {
      // alert('word');
      // return false;
    }
  };
  // const [notify, setNotify] = useState(false);
  const checkIfConnected = (type, e) => {
    // props?.setMessage(e.target.value);
    setShowEmoji(false);
    console.log('event==', e.target.value, e);
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      // alert('1');
    }
    e.preventDefault();
    if (props?.fromSearch && e?.target?.value?.trim()?.length != 0) {
      setShowSearch(false);
      setSharedUserClicked('');
      setShowFirstMessage('');
      props?.setMessages([]);
      if (window.innerWidth < 650) {
        setShowUsers(false);
        setShowAbsolute(false);
      } else {
        setShowUsers(true);
        setShowAbsolute(true);
      }
    }
    if (e?.target?.value?.trim()?.length != 0) {
      props?.handleSendMessage(type, e);
    }
    // let check = users?.findIndex(
    //   (x) =>
    //     x?.channelUser?.channelName == localStorage.getItem('userName') ||
    //     x?.channelUser?.username == localStorage.getItem('userName')
    // );
    // console.log('check==', 'hhh', check);
    // if (check == -1) {
    //   socket.on('connect', () => {
    //     handleSendMessage(type, e);
    //   });
    // } else {
    //   handleSendMessage(type, e);
    // }
  };
  const newSendFile = (type, e) => {
    console.log('event==', e.target.value);
    e.preventDefault();
    if (props?.fromSearch) {
      setShowSearch(false);
      setSharedUserClicked('');
      setShowFirstMessage('');
      props?.setMessages([]);
      if (window.innerWidth < 650) {
        setShowUsers(false);
        setShowAbsolute(false);
      } else {
        setShowUsers(true);
        setShowAbsolute(true);
      }
    }
    const formData = new FormData();
    formData.append('file', e.target.files[0]);

    ref.current.emit('private:uploadFile', formData);
  };

  useEffect(() => {
    ref?.current?.on('private:uploadFileResponse', (data) => {
      console.log('messageis===', data);
    });
  }, [ref]);
  const sendContactFunction = () => {
    if (props?.fromSearch) {
      setShowSearch(false);
      setShowFirstMessage('');
      props?.setMessages([]);
      if (window.innerWidth < 650) {
        setShowUsers(false);
        setShowAbsolute(false);
      } else {
        setShowUsers(true);
        setShowAbsolute(true);
      }
    }
    const userChosen = JSON.stringify(userChosenForShare);
    if (props?.chatTypePrivate) {
      // alert('11');
      console.log('userChannelId', userChannelId, activeUser);
      props?.sendContact(userChosen);
      // ref?.current?.emit(
      //   'private:message',
      //   {
      //     text: userChosen,
      //     type: 'contact',
      //     // name: localStorage.getItem('userName'),
      //     // id: `${socket.id}${Math.random()}`,
      //     socketID: ref?.current?.id,
      //     uuid: userChannelId,
      //     replyId: props?.replyValue?.id,
      //     typeId: activeUser?.typeId,
      //     roomId: activeUser?.id,
      //   },
      //   (response) => {
      //     props?.setLoadingFile(false);
      //     if (response?.status == 'error') {
      //       props?.setServerError(response?.message);
      //     } else {
      //       props?.setServerError('');
      //     }
      //   }
      // );
    }
  };
  // const notifyFunction = () => {
  //   alert('1');
  //   socketRef.current.on('private:popUpNotif', (data) => {
  //     console.log('fffffffffff', data);

  //     window.electron.ipcRenderer.sendMessage('showNotification', data);
  //     setNotify(false);
  //   });
  // };
  // useEffect(() => {
  //   if (notify) {
  //     notifyFunction();
  //   }
  // }, [notify]);

  // const notTyping = () => {
  //   // if (socket) {
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.emit(
  //       'private:typing',
  //       { type: ``, uuid: userChannelId },
  //       (response) => {
  //         if (response?.status == 'error') {
  //           props?.setServerError(response?.message);
  //         } else {
  //           props?.setServerError('');
  //         }
  //       }
  //     );
  //   } else {
  //     ref?.current?.emit('multiple:typing', ``, (response) => {
  //       if (response?.status == 'error') {
  //         props?.setServerError(response?.message);
  //       } else {
  //         props?.setServerError('');
  //       }
  //     });
  //   }
  //   // }
  // };

  return (
    <div
      className={`flex flex-col justify-start items-start w-full h-auto relative footer__border ${
        props?.extraFooterStyle
      }
      ${props?.replyValue?.id?.length != 0 && 'blur'}
      `}
    >
      <ReplyBox
        replyValue={props?.replyValue}
        setReplyValue={props?.setReplyValue}
        direction={direction}
      />
      <div className="chat__footer relative" ref={emojiRef}>
        {showEmoji && (
          <Emoji setMessage={props?.setMessage} message={props?.message} />
        )}
        <form
          className={`form absolute ${styles.zIndex}`}
          onSubmit={(e) => {
            login && !props?.loadingFileButton
              ? props?.loadingFile
                ? console.log('loading')
                : checkIfConnected('', e)
              : e.preventDefault();
            console.log('loading');
          }}
        >
          <div className={styles.footerInputContainer}>
            <div
              onClick={() => {
                setShowEmoji(!showEmoji);
              }}
              className={`flex justify-row justify-center items-center h-full`}
            >
              <AppIcons.emojiIcon
                className={`noFilterSvg ${styles.emojiIcon}`}
              />
            </div>
            <textarea
              rows={1}
              type="text"
              placeholder={props?.content?.chatPage?.footer?.InputPlaceHolder}
              className={`message ${
                themeMode == 'dark' ? 'modalHeaderBg textWhite noBorder' : ''
              } bgWhite messageInput`}
              value={props?.message}
              onChange={(e) => {
                console.log('eeeeeeee', e.target.value);
                props?.setMessage(e.target.value);
                // handleTyping();
              }}
              disabled={!login}
              onKeyDown={
                login
                  ? (e) => {
                      handleTyping();
                      textareaKeydown(e);
                    }
                  : props?.setServerError(
                      `${props?.content?.chatPage?.footer?.notConnectText}`
                    )
              }
              onBlur={() => {
                props?.notTyping();
              }}
            />
            <Button
              disabled={!login || props?.loadingFileButton}
              className={`${styles.sendButton} ${
                !login || props?.loadingFileButton ? 'disabledBtn' : ''
              }`}
              onClick={(e) => {
                login
                  ? props?.loadingFile || props?.loadingFileButton
                    ? console.log('loading')
                    : checkIfConnected('', e)
                  : props?.setServerError(
                      `${props?.content?.chatPage?.footer?.notConnectText}`
                    );
              }}
            >
              {props?.loadingFile ? (
                <Loader
                  className={'lds_ring'}
                  width="w-[35px]"
                  height="h-[35px]"
                />
              ) : (
                <span>{props?.content?.chatPage?.footer?.sendButton}</span>
              )}
            </Button>
          </div>
          {/* <FileButton
            login={login}
            themeColor={themeColor}
            loadingFileButton={props?.loadingFileButton}
            content={props?.content}
            loadingFile={props?.loadingFile}
            type={type}
            direction={direction}
            checkIfConnected={checkIfConnected}
            message={props?.message}
            onClick={()=>{setShowEmoji(false)}}
          >
            <label
              className={`${styles.fileUpload} w-full cursor-pointer ${
                !login ? 'disableUpload' : ''
              }`}
            >
              <input
                type="file"
                className={themeColor != 'white' ? 'onlineChatInput' : ''}
                onChange={(e) => {
                  login
                    ? props?.loadingFile
                      ? console.log('loading')
                      : checkIfConnected('file', e)
                    : console.log('loading');
                }}
                id="fileUploadChat"
                accept={`${type}`}
                // accept={`application/x-rar-compressed `}
                disabled={!login}
              />

              {props?.loadingFileButton ? (
                <Loader className={'lds_ring'} width="w-auto" height="h-auto" />
              ) : (
                <div className={`flex flex-row justify-start items-center `}>
                  <AppIcons.UploadImageIcon />
                  <span
                    className={`mx-8px ${themeMode != 'white' && 'textWhite'}`}
                  >
                    {props?.content?.chatPage?.footer?.uploadButton}
                  </span>
                </div>
              )}
            </label>
          </FileButton> */}
          <div className={`relative`}>
            <div className={styles.fileButton}>
              <label
                className={`${styles.fileUpload} w-full cursor-pointer ${
                  !login ? 'disableUpload' : ''
                }`}
              >
                <input
                  type="file"
                  className={themeColor != 'white' ? 'onlineChatInput' : ''}
                  onChange={(e) => {
                    login
                      ? props?.loadingFile
                        ? console.log('loading')
                        : checkIfConnected('file', e)
                      : console.log('loading');
                  }}
                  id="fileUploadChat"
                  accept={`${type}`}
                  // accept={`application/x-rar-compressed `}
                  disabled={!login}
                />

                {props?.loadingFileButton ? (
                  <Loader
                    className={'lds_ring'}
                    width="w-auto"
                    height="h-auto"
                  />
                ) : (
                  <div className={`flex flex-row justify-center items-center `}>
                    <img src={attachIcon} />
                  </div>
                )}
              </label>
            </div>
          </div>
        </form>
      </div>

      {openShare && (
        <CenterModal
          containerStyle={`${styles.modalStyle} ${
            !props?.showFirstMessage && styles.shareUserWidth
          } ${direction == 'rtl' ? styles.modalRtl : styles.modalLtr}`}
          handleShowModal={() => {
            setOpenShare(false);
            setUserChosenForShare({});
          }}
          userChosenForShare={userChosenForShare}
          setUserChosenForShare={setUserChosenForShare}
          ref={shareModalRef}
          showCloseButton={false}
        >
          <ShareUsersContent
            userChosenForShare={userChosenForShare}
            setUserChosenForShare={setUserChosenForShare}
            submitFunction={() => {
              sendContactFunction();
            }}
          />
        </CenterModal>
      )}
      {forwardMessages && (
        <CenterModal
          containerStyle={`${styles.modalStyle} ${
            !props?.showFirstMessage && styles.shareUserWidth
          } ${direction == 'rtl' ? styles.modalRtl : styles.modalLtr}`}
          handleShowModal={() => {
            setForwardMessages();
          }}
          userChosenForShare={userChosenForShare}
          setUserChosenForShare={setUserChosenForShare}
          ref={shareModalRef}
          showCloseButton={false}
        >
          <ForwardMessages
            forwardMessages={forwardMessages}
            setForwardMessages={setForwardMessages}
            ref={ref}
            // submitFunction={() => {
            //   forwardFunction();
            // }}
          />
        </CenterModal>
      )}
    </div>
  );
});

export default ChatFooter;
